(function ($) {
    function toggleSubMenu(e) {
        e.preventDefault();

        var elem = $(this);

        var ul = elem.closest('li').find('ul').first();
        ul = $(ul);

        if (elem.hasClass('expanded')) {
            ul.slideUp();
        } else {
            ul.slideDown();
        }
        elem.toggleClass('expanded');
    }

    function toggleMobileMenu(e) {
        e.preventDefault();
        var topNavContainer = $('.slide-drawer');
        var cover = $('#cover');
        if (topNavContainer.hasClass('open')) {
            cover.hide();
        } else {
            cover.show();
        }
        topNavContainer.toggleClass('open');
    }

    function cleanupMobileMenu() {
        var topNav = $('.slide-drawer');
        var breakPoint = 1090;

        if ($(window).width() >= breakPoint) {
            topNav.css('display', '');
            topNav.removeClass('open');
            topNav.find('ul').css('display', '');
            topNav.find('.expanded').removeClass('expanded');
        }
    }

    function initMobileMenu() {
        var linkContainer = $('.top-nav-toggle');
        var toggle = linkContainer.find('a');
        var topNav = $('.nav-primary');

        var linkWithChildren = topNav.find('.menu-item-has-children');

        linkWithChildren.each(function (key, elem) {
            var elemLink = $(elem).find('a').first();
            var link = $('<a href="#" />').addClass('expander');
            var div = $('<div />');
            var svgLink = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            var useLink = document.createElementNS('http://www.w3.org/2000/svg', 'use');
            useLink.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#symbol-down-arrow');

            link.on('click', toggleSubMenu);

            svgLink.appendChild(useLink);
            link.append(div);
            div.append(svgLink);
            link.insertAfter(elemLink);
        });

        toggle.on('click', toggleMobileMenu);

        $('#cover').on('click', toggleMobileMenu);
    }

    $(document).ready(initMobileMenu);
    $(window).resize(cleanupMobileMenu);
})(jQuery);